/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'undo': {
    width: 16,
    height: 16,
    viewBox: '0 0 20.47 9',
    data: '<path pid="0" d="M10.5 1a10.464 10.464 0 0 0-6.9 2.6L0 0v9h9L5.38 5.38A7.953 7.953 0 0 1 10.5 3.5 8.012 8.012 0 0 1 18.1 9l2.37-.78A10.514 10.514 0 0 0 10.5 1z"/>'
  }
})
